module.exports = __webpack_public_path__ + "static/media/App-We.d48a2131.jpg";